import React,{useContext} from 'react'
import { GlobalContext } from '../../../../context/provider';
import numberbeautify from '../../../../utils/numberbeautify';
import money_rounding from '../../../../utils/money_rounding';
import { useNavigate } from 'react-router-dom';

const Mizania_customer_loan_table = ({data, mizania_date}) => {
    const { initState, initDispatch } = useContext(GlobalContext);
    const navigate = useNavigate();
    return (
        <div>
            <div className="mt-6">
                {/* Category List Card */}
                <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                    
                    {/* Section Header */}
                    <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                        <h2 className="text-base font-semibold text-slate-800">لیستی قەرزی کڕیار</h2>
                    </div>
    
                    {/* Table */}
                    <table className="w-full">
                        <thead>
                            <tr className="bg-slate-50 border-b border-slate-100">
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    ناوی کڕیار
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    ناونیشان
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    ژمارە
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    بڕی قەرزی ماوە
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                            {data?.map((lis)=>(
                            <tr key={lis.customer_id} className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    <p className={lis.customer_id==1?"text-slate-800 whitespace-nowrap":"text-indigo-600 whitespace-nowrap underline cursor-pointer"}
                                        onClick={() =>{
                                        if(lis.customer_id!=1){
                                            initDispatch({type:'setmizania_customer_ledger', payload:{mizania_date:mizania_date,mizania_customer_id:lis.customer_id, mizania_customer_name:lis.customer_name, mizania_customer_phone:lis.customer_phone, mizania_customer_address:lis.customer_address}});
                                            navigate('/report/mizania/customer_ledger');
                                        }
                                        }}
                                    >
                                        {lis.customer_name}
                                    </p>
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.customer_address}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.customer_phone}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(money_rounding(lis.total_amount))} $
                                </td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Mizania_customer_loan_table